import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@oniratec/onira-react-ui/styles.css';
import './styles/globals.css';
import './lib/i18n/i18n';

async function bootstrap() {
  const apiMode = import.meta.env.VITE_API_MODE;

  if (apiMode === 'mock') {
    const { setupWorker } = await import('msw/browser');
    const { mockHandlers } = await import('./mocks/handlers');
    const worker = setupWorker(...mockHandlers);
    await worker.start({ onUnhandledRequest: 'bypass' });
  } else {
    const { registerSW } = await import('virtual:pwa-register');
    registerSW({ immediate: true });
  }

  const root = document.getElementById('root');
  if (!root) {
    throw new Error('Root element not found');
  }

  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

bootstrap();
